import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center p-6">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1521194263619-39ecc5b55c61?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000')" }}
      />
      <div className="absolute inset-0 bg-white/80 backdrop-blur-sm" />
      <div className="relative w-full max-w-md bg-white border border-slate-200 p-10" data-testid="login-card">
        <div className="mb-8">
          <div className="font-serif text-4xl tracking-tight text-slate-900 leading-none">Pramaana</div>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mt-2">Founder Intelligence</div>
          <p className="text-sm text-slate-500 mt-5 italic font-serif text-lg">One Sankalpa. One Verified Record.</p>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className="font-mono text-[11px] uppercase tracking-wider text-slate-500">Email</Label>
            <Input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 rounded-sm border-slate-300"
              autoComplete="username"
              required
            />
          </div>
          <div>
            <Label className="font-mono text-[11px] uppercase tracking-wider text-slate-500">Password</Label>
            <Input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 rounded-sm border-slate-300"
              autoComplete="current-password"
              required
            />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2 rounded-sm">{error}</div>}
          <Button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full rounded-sm bg-slate-900 hover:bg-slate-800 text-white h-11"
          >
            {loading ? "Authenticating…" : "Enter"}
          </Button>
        </form>
        <p className="text-xs text-slate-400 mt-6 font-mono">Private founder access only. No public registration.</p>
      </div>
    </div>
  );
}
